import { AXIOS } from "@/AXIOS/http-common";

const state = {
  list: [],
  isCurrentUserWhitelisted: false,
};

const urlPrefix = "old-record-whitelist";

const actions = {
  async getOldRecordWhitelist(context) {
    return await AXIOS.get(urlPrefix).then((response) => {
      context.commit("setOldRecordWhitelist", response.data);
    });
  },

  async getIsCurrentUserWhitelisted(context) {
    return await AXIOS.get(urlPrefix + "/isCurrentUserWhitelisted").then(
      (response) => {
        context.commit("setIsCurrentUserWhitelisted", response.data);
      }
    );
  },

  async addOldRecordWhitelistUser(context, username) {
    return await AXIOS.post(urlPrefix + "/by-username/" + username);
  },

  async removeOldRecordWhitelistUser(context, userId) {
    return await AXIOS.delete(urlPrefix + "/" + userId);
  },
};

const mutations = {
  setOldRecordWhitelist(state, data) {
    state.list = data;
  },

  setIsCurrentUserWhitelisted(state, data) {
    state.isCurrentUserWhitelisted = data;
  },
};

const getters = {
  GETOLDRECORDWHITELIST: (state) => state.list,
  GETISCURRENTUSERWHITELISTED: (state) => state.isCurrentUserWhitelisted,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
